// Non-URL Environment Config and Flags
export const STORAGE_ACCOUNT = process.env.REACT_APP_STORAGE_ACCOUNT;
export const GOOGLE_ID = process.env.REACT_APP_GOOGLE_ID;
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
export const APP_NAME = process.env.REACT_APP_APPLICATION_NAME;
export const DECRYPTION_KEY_HEX = process.env.REACT_APP_DECRPTION_KEY_HEX;
export const ENVIRONMENT = process.env.REACT_APP_Environment;

export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_ApiKey,
  authDomain: process.env.REACT_APP_AuthDomain,
  databaseURL: process.env.REACT_APP_DatabaseURL,
  projectId: process.env.REACT_APP_ProjectId,
  storageBucket: process.env.REACT_APP_StorageBucket,
  messagingSenderId: process.env.REACT_APP_MessagingSenderId,
  appId: process.env.REACT_APP_AppId,
};

export const NODE_ENV = process.env.NODE_ENV;
export const PUBLIC_URL = process.env.PUBLIC_URL;

// Derived flags
export const IS_PROD = ENVIRONMENT === "production" || NODE_ENV === "production";
